function formatThousands(value, options = {}) {
    const { locale = "en-US", minimumFractionDigits = 0, maximumFractionDigits = minimumFractionDigits, } = options;
    const n = Number(value);
    if (!Number.isFinite(n))
        return "";
    return new Intl.NumberFormat(locale, {
        useGrouping: true,
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(n);
}

export { formatThousands };
